import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs'

import { AuthenticationService } from '../../core/authentication.service';
import { UserDetails } from '../../shared/interfaces/user-details';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css']
})
export class TopBarComponent implements OnDestroy {
  userData: UserDetails = {
    username: '',
    isUserLoggedIn: false,
    isSuperUser: false
  }
  _userSubscription: Subscription
  constructor(private authenticationService: AuthenticationService) {
    this._userSubscription = authenticationService.savedUser.subscribe((userUpdate: UserDetails) => {
      this.userData = userUpdate
    })
  }

  ngOnDestroy() {
    this._userSubscription.unsubscribe()
  }
}
